export default __webpack_public_path__ + "static/avatar-kayi-common-4-45416e239dd9435a55cc895c999ae5fe.png";